// 히어로 스트립 — 요약 숫자는 화면에서 여기 한 번만 (시안 .hero, 말소대행 시그니처 그라디언트).
// props: metrics:[{label, value, unit, sub, tone:'default'|'danger'|'money'|'accent'|'faint', onClick}], isMobile, hideZeroSub(기본 true)
// 요약 지표의 0 은 '0' 이다 — 화면들이 fmtNum(0) = '-' 를 넘겨도 히어로는 '0' 으로 그린다(표 셀의 '-' 규칙은 그대로).
// sub 가 숫자를 담고 있는데 그 숫자가 전부 0 이면(`0/0대`·`회전율 0 · 이달 처리 0`) 읽을 게 없다 → sub 생략(hideZeroSub={false} 로 해제).
// 데스크톱 = 가로 flex(세로 구분선) / 모바일 = 2열 grid minmax(0,1fr) (긴 금액이 칸을 밀어 페이지가 넘치지 않게).
// 클래스 `.v2-hero`(루트) / `.v2-hero-cell`(칸) — 화면 테스트 셀렉터용. 시각 규칙은 전부 인라인이라 CSS 는 없다.
import React from 'react';
import { T, R, FONT, NUM, zeroText } from '../theme';

var TONE = { danger: T.danger, money: T.money, accent: T.accentPress, faint: T.faint };

var wrapDesk = { display: 'flex', background: T.heroBg, border: '1px solid ' + T.heroBd, borderRadius: R.card, padding: '12px 18px', marginBottom: 14 };
var wrapMob = { display: 'grid', gridTemplateColumns: 'minmax(0,1fr) minmax(0,1fr)', columnGap: 12, rowGap: 12,
  background: T.heroBg, border: '1px solid ' + T.heroBd, borderRadius: R.card, padding: '13px 14px', marginBottom: 14 };
var lbl = { fontSize: FONT.label, fontWeight: 700, color: T.muted, letterSpacing: '.2px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' };
var unitSt = { fontSize: 12, fontWeight: 600, color: T.muted, marginLeft: 2, letterSpacing: 0 };
var subSt = { fontSize: FONT.label, color: T.faint, marginTop: 2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' };

// 숫자가 하나도 없는 sub('매입가 합계')는 설명문이라 남긴다. 숫자가 있는데 전부 0 이면 숨긴다.
export function isZeroSub(sub) {
  if (typeof sub !== 'string') return false;
  var nums = sub.match(/\d[\d,.]*/g);
  if (!nums) return false;
  return nums.every(function (n) { return Number(n.replace(/,/g, '')) === 0; });
}

function HeroStrip(props) {
  var isMobile = props.isMobile;
  var metrics = props.metrics || [];
  var hideZeroSub = props.hideZeroSub !== false;
  return (<div className="v2-hero" style={isMobile ? wrapMob : wrapDesk}>
    {metrics.map(function (m, i) {
      var first = i === 0;
      var cell = isMobile
        ? { minWidth: 0 }
        : { flex: 1, minWidth: 0, padding: first ? '0 16px 0 0' : '0 16px', borderLeft: first ? 'none' : '1px solid ' + T.hair };
      if (m.onClick) cell = Object.assign({}, cell, { cursor: 'pointer' });
      var val = Object.assign({ fontSize: FONT.hero, fontWeight: 800, color: TONE[m.tone] || T.ink, letterSpacing: '-.5px', lineHeight: 1.25, marginTop: 2,
        whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }, NUM);
      return (<div key={m.key || m.label || i} className="v2-hero-cell" style={cell} onClick={m.onClick} role={m.onClick ? 'button' : undefined}>
        <div style={lbl}>{m.label}</div>
        <div style={val}>{zeroText(m.value)}{m.unit ? <small style={unitSt}>{m.unit}</small> : null}</div>
        {m.sub && !(hideZeroSub && isZeroSub(m.sub)) ? <div style={subSt}>{m.sub}</div> : null}
      </div>);
    })}
  </div>);
}

export default HeroStrip;
